<template>
  <div class="common-upload-container flex justify-center items-center" :class="{ 'min-client-height': minClient }">
    <div class="upload-position-container">
      <div class="upload-box upload-single flex justify-center items-center" @mouseenter="handleShowImageList"
        @mouseleave="handleHiddenImageList" v-authenticate:BACKGROUND_BLUR>
        <commonUpload :fileList="fileList" :setFileList="setFileList" :multiple="false" :customRequest="customRequest"
          :reUpload="reUpload" accept=".JPG,.jpg,.png,.PNG,.webp,.WEBP,.jpeg,.JPEG" placeHolder="Upload a portrait image"
          :limitNum="10" :iconUrl="iconUploadSingle" creditTip="&nbsp" :iconStyle="{
              width: '46px',
              height: '58px',
              'margin-bottom': '25px',
            }" />
      </div>
      <div class="image-box-background" @mouseenter="handleShowImageList" @mouseleave="handleHiddenImageList"
        v-if="isShowImageList">
        <div class="inner-image-box">
          <div class="box-arrow"></div>
          <p class="tooltip-title">No image? Try one of these</p>
          <div class="example-images-box">
            <div class="example-image-icon-box" v-for="item in imagesList" :key="item.id"
              v-authenticate:BACKGROUND_BLUR="{ ok: () => handleSelectImage(item) }">
              <div class="mask-item"></div>
              <img :src="item.iconSrc" class="example-image-icon" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="upload-box upload-multiple flex justify-center items-center" v-authenticate:BOOLTOOL_BATCH_PROCESS>
      <commonUpload :fileList="fileList" :multiple="true" :setFileList="setFileList" :reUpload="reUpload"
        accept=".JPG,.jpg,.png,.PNG,.webp,.WEBP,.jpeg,.JPEG" :customRequest="customBatchRequest" :limitNum="20"
        :iconUrl="iconUploadMultiple" :iconStyle="{
            width: '57px',
            height: '69px',
            'margin-bottom': '25px',
          }" placeHolder="Batch upload (Max 20 images)"
        :creditTip="batchProcessResource.unlimitedNum ? '&nbsp;' : `Balance: ${batchProcessResource.num || 0}`" />
    </div>

  </div>
</template>
<script setup>
import { ref, defineEmits, onUnmounted, onMounted } from "vue";
import commonUpload from "@/components/custom-upload/index.vue";
import { storeToRefs } from 'pinia'
import loadImage from "blueimp-load-image";
import { authenticator } from "@/utils";
import dataUtils from "@/utils/util.js";
import {
  MessageLoading,
  destroy,
} from "@/components/boolv-ui/Message/index.js";
import iconUploadSingle from "@/assets/upload-images/icon_upload_single.svg";
import iconUploadMultiple from "@/assets/upload-images/icon_upload_mutiple_pro.svg";
import blur1 from "./img/blur1.webp";
import blur2 from "./img/blur2.webp";
import blur3 from "./img/blur3.webp";
import blur1_src from "./img/blur1_src.webp"
import blur2_src from "./img/blur2_src.webp";
import blur3_src from "./img/blur3_src.webp";

import { useUserStore, useCheckResourceStore, useSideStore, useViewStore, useSubscriptionInfo } from '@/store/index.js'
const user = useUserStore();
const subscriptionInfo = useSubscriptionInfo();
const { deductResourceFn } = useCheckResourceStore()
const sideStore = useSideStore()
const viewStore = useViewStore()
const { minClient } = storeToRefs(sideStore)

const uploadFileList = ref([]);
const uploadCount = ref(0);
const isUploading = ref(false);
const formateImageList = ref([]);
const isShowImageList = ref(false);
const currentSelectItem = ref(null);
const isBatch = ref(false);
const reUpload = ref(false);
const batchProcessResource = subscriptionInfo.getUserResource("BOOLTOOL_BATCH_PROCESS");

const imagesList = ref([
  {
    id: 1,
    iconSrc: blur1,
    src: blur1_src,
  },
  {
    id: 2,
    iconSrc: blur2,
    src: blur2_src,
  },
  {
    id: 3,
    iconSrc: blur3,
    src: blur3_src,
  },
]);
const preload = () => {
  imagesList.value.forEach(item => {
    const img = new Image();
    img.src = item.iconSrc;
  })
}
onMounted(() => {
  // viewStore.setMinViewWidth('1400px')
  preload();
})
const emits = defineEmits(["uploadComplete"]);

const setIsBatch = (value) => {
  isBatch.value = value;
  emits("isBatch", value);
}
// 单张上传
const customRequest = () => {
  setIsBatch(false)
  reUpload.value = true
};

const handleSelectImage = (item) => {
  setIsBatch(false)
  currentSelectItem.value = item;
  sessionStorage.setItem("sourceImageId", JSON.stringify([`default_image_${item.id}`]));
  uploadFileList.value = [item.src];
  formateImageList.value = formateImageToImageData([item.src]);
};
// 多张上传
const customBatchRequest = () => {
  setIsBatch(true)
  reUpload.value = true
};
// 本地上传完成
const setFileList = (fileList = []) => {
  destroy()
  MessageLoading("Uploading, it will take a while");
  const fileArray = fileList.map((file) => file.originFileObj);
  uploadFileList.value = fileArray;
  formateImageList.value = formateImageToImageData(fileArray);
};
// 转换imageData数据格式
const formateImageToImageData = (fileList) => {
  const uploadImageData = [];
  uploadCount.value = 0;
  isUploading.value = true;
  fileList.forEach((file, index) => {
    loadImage(
      file,
      async (img) => {
        if (img.type === "error") {
          console.log("error");
        } else {
          const tempCtx = dataUtils.createCanvasCtx(img);
          tempCtx.drawImage(img, 0, 0);
          const imageData = tempCtx.getImageData(0, 0, img.width, img.height);

          uploadImageData.push({
            id: index + 1,
            img,
            file: file,
            operationalData: tempCtx.getImageData(0, 0, img.width, img.height),
            originImageData: imageData, //不可更改
          });

          uploadCount.value += 1;

          if (uploadCount.value === uploadFileList.value.length) {
            isUploading.value = false;

            if (isBatch.value) {
              // 批量才检查资源且扣费, 检查失败关闭弹窗
              try {
                // await checkCurrentResource('BACKGROUND_BLUR', isBatch.value)
                await deductResourceFn('BACKGROUND_BLUR', isBatch.value, uploadFileList.value.length)
                await authenticator.refresh();
                // 上传完成
                destroy()
                emits("uploadComplete", formateImageList.value);

              } catch (err) {
                reUpload.value = true
              }
            } else {
              destroy()
              emits("uploadComplete", formateImageList.value);

            }
          }
        }
      },
      {
        cover: true,
        crop: true,
        canvas: true,
        crossOrigin: "Anonymous",
      }
    );
  });
  return uploadImageData;
};
// 示例显隐
const handleShowImageList = () => {
  isShowImageList.value = true;
};

const handleHiddenImageList = () => {
  isShowImageList.value = false;
};

onUnmounted(() => {
  destroy()
})

</script>

<style lang="less" scoped>
.common-upload-container {
  min-height: calc(100vh - 60px);
  padding: 60px 0;
  min-width: 1400px;

  .tooltip-card {
    width: 394px;

    left: "280px";
  }

  :global(.ant-tooltip-content) {
    width: 394px;
    height: 100%;
  }

  :global(.ant-tooltip-inner) {
    width: 394px;
    height: 100%;
    color: #8f959e;
  }
}

.upload-box {
  width: 277px;
  height: 196px;
  padding-top: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background-color: #f8f5ff;
  }
}

.upload-single {
  margin-right: 34px;
}

.example-images-container {
  width: 394px;

  background-color: green;
}

.example-image-icon {
  width: 110px;
  height: 110px;
  border-radius: 4px;
  object-fit: cover;
}

.example-images-box {
  display: flex;
  justify-content: space-between;
  padding: 22px 20px;
}

.image-box-background {
  width: 394px;
  height: 230px;
  position: absolute;
  padding-top: 14px;
  left: -60px;
}

.inner-image-box {
  width: 394px;
  height: 212px;
  position: absolute;
  // background-color: green;
  margin-top: 14px;

  background: #ffffff;
  border: 1px solid #f1f1f1;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
}

.upload-position-container {
  position: relative;
}

.example-image-icon-box {
  cursor: pointer;
  position: relative;
  background-color: #F6F6F6;
  width: 110px;
  height: 110px;
  border-radius: 4px
}


.mask-item {
  position: absolute;
  width: 110px;
  height: 110px;
  border-radius: 4px;
  opacity: 0;
  background-color: #000;
  transition: all .3s;
  cursor: pointer;

  &:hover {
    opacity: 0.3;
  }

}

.inner-image-box:before {
  width: 0px;
  height: 0px;
  position: absolute;
  left: 50%;
  margin-left: -8px;
  top: -32px;
  padding: 0;
  border: 16px solid transparent;
  border-color: transparent transparent #ffffff transparent;
  content: '';
  z-index: 12;
}

.inner-image-box:after {
  width: 0px;
  height: 0px;
  position: absolute;
  left: 50%;
  margin-left: -9.5px;
  top: -35px;
  padding: 0;
  border: 17.5px solid transparent;
  border-color: transparent transparent #f1f1f1 transparent;
  content: '';
  z-index: 10
}
</style>
